import { SignupErrorInvalidToken, SignupLoadInit } from 'components/account'
import { ErrorMessage } from 'components/account/signup/Steps'
import { Formik } from 'formik'
import React from 'react'
import { I18n } from 'react-redux-i18n'
import { Alert, Button } from 'reactstrap'
import { bindActionCreators } from 'redux'
import { nxAuthTokenAct } from 'redux_new/actions'
import { signup as apiSignup } from '../../../../api'
import '../styles.scss'
import operatorActions from 'redux/actions/user'
import { useDispatch } from 'react-redux'
import { isValidPassword } from 'utils/helpers'
import Nixi1Spinner from 'components/Nixi1Spinner'
import LandingLocale from 'components/common/LandingLocale'

const PageChangePassword = (props) => {
  const dispatch = useDispatch()
  const operatorActs = bindActionCreators(operatorActions, dispatch)
  const onNxAuthToken = bindActionCreators(nxAuthTokenAct, dispatch)

  const tokenPassword = props.match.params.token

  const MAP_FIELD_ERRORS = {
    password: I18n.t('form_input_password_error'),
    password2Match: I18n.t('nfrl_new_password_input_password_not_match'),
    password2Required: I18n.t('nfrl_new_password_input_repeat_password')
  }

  const MAP_FIELD_ERRORS_PASSWORD = {
    error_string: I18n.t('form_input_password_error_number_string'),
    error_space: I18n.t('form_input_password_error_space'),
    error_min_length: I18n.t('form_input_password_error_min_length')
  }

  const initialValues = {
    password: '',
    password2: ''
  }

  // const [errors, setErrors] = React.useState({})
  const [loadingForm, setLoadingForm] = React.useState(false)
  const [errorToken, setErrorToken] = React.useState(false)
  const [loadingInit, setLoadingInit] = React.useState(true)
  const [errorGeneral, setErrorGeneral] = React.useState(false)
  const [validateStatus, setValidateStatus] = React.useState(false)

  const submitFields = (values) => {
    sendNewPassword(values.password)
  }

  const validateFields = (values) => {
    const errors = {}

    const checkValidPassword = isValidPassword(values.password)
    if (checkValidPassword.length > 0) {
      errors.password = checkValidPassword
    }

    if (!values.password2) {
      errors.password2Required = MAP_FIELD_ERRORS.password2Required
    } else if (values.password2 !== values.password) {
      errors.password2Match = MAP_FIELD_ERRORS.password2Match
    }

    if (!validateStatus) {
      setValidateStatus(true)
    }
    return errors
  }

  const sendNewPassword = (password) => {
    setLoadingForm(true)
    return apiSignup.changePassword({ token: tokenPassword, password }).then(({ status, data }) => {
      onNxAuthToken.add(data.token)
      return data.token
    }).then((authToken) => {
      operatorActs.getOperator(authToken, false)
    }).catch(({ response: { data } }) => {
      if (data.type === 'error_not_valid_email') {
        // setErrors({ email: MAP_FIELD_ERRORS.email })
      } else {
        setErrorGeneral(true)
      }
      setLoadingForm(false)
    })
  }

  const checkTokenPassword = () => {
    return apiSignup.checkTokenPassword(tokenPassword).then(({ status, data }) => {
      setLoadingInit(false)
    }).catch(({ response: { data } }) => {
      setErrorToken(true)
      setLoadingInit(false)
    })
  }

  React.useEffect(() => {
    checkTokenPassword()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tokenPassword])

  const htmlForm = () => (
    <div className='nfrl'>
      <div className='animated fadeIn'>
        <div className='logo-container'>
          <img src={'/img/logo-white.svg'} alt='Logo' />
        </div>

        <Formik initialValues={initialValues} onSubmit={submitFields} validate={validateFields} validateOnChange={validateStatus}>
          {({ values, handleChange, handleSubmit,errors, isSubmitting }) => (
            <div className="page-container">
              <div className="form-container">
                <div className='form-title'>{I18n.t('dashboard_new-password')}</div>
                <div className='form-subtitle'>{I18n.t('nfrl_new_password_subtitle')}</div>
                {
                  errorGeneral &&
                  <div className="signup-operator-alert-token">
                    <Alert color='danger'>{I18n.t('signup_generic_error')}</Alert>
                  </div>
                }

                <div className='personal-form'>
                  <input type='password' name='password' placeholder={I18n.t('dashboard_new-password')} onChange={handleChange} value={values.password} />
                  {errors.password ? errors.password.map(el => (<ErrorMessage key={el} text={MAP_FIELD_ERRORS_PASSWORD[el]}/>)) : null}
                </div>

                <div className='personal-form'>
                  <input type='password' name='password2' placeholder={I18n.t('nfrl_new_password_input_repeat_password')} onChange={handleChange} value={values.password2} />
                  {errors.password2Required ? <ErrorMessage text={errors.password2Required} /> : null}
                  {errors.password2Match ? <ErrorMessage text={errors.password2Match} /> : null}
                </div>

                <Button className='submit-button' onClick={handleSubmit}>
                  {
                    loadingForm
                      ? <Nixi1Spinner width={'1.5rem'} height={'1.5rem'} />
                      : <div>{I18n.t('dashboard_save')}</div>
                  }
                </Button>
              </div>
            </div>
          )}
        </Formik>
      </div>
      <LandingLocale
        direction='top'
        darkMode
      />
    </div>
  )

  if (loadingInit) {
    return <SignupLoadInit></SignupLoadInit>
  } else if (errorToken) {
    return <SignupErrorInvalidToken showBtnLogin="true" clickBtnLogin={() => props.history.push('/login')} title={I18n.t('nfrl_new_password_error_token_title')} description={I18n.t('nfrl_new_password_error_token_description')}></SignupErrorInvalidToken>
  } else {
    return htmlForm()
  }
}

export default PageChangePassword